export default "__VITE_ASSET__D0UD3gHs__"